import { render } from "./AssignArticlesModal.vue?vue&type=template&id=6181d0c2&scoped=true"
import script from "./AssignArticlesModal.vue?vue&type=script&lang=js"
export * from "./AssignArticlesModal.vue?vue&type=script&lang=js"

import "./AssignArticlesModal.vue?vue&type=style&index=0&id=6181d0c2&lang=stylus&scoped=true"
import "./AssignArticlesModal.vue?vue&type=style&index=1&id=6181d0c2&lang=stylus"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6181d0c2"]])

export default __exports__